import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close, Plus, TriangleDown } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { memo, useCallback } from "react";
import { FiltersDropdownTrigger } from "~/components/Filters/FiltersButton/FiltersDropdownTrigger";
import { useFiltersDropdownController } from "~/components/Filters/FiltersDropdown/useFiltersDropdownController";
import { PublicFiltersDropdown } from "~/components/Filters/v2/components/PublicFiltersDropdown";
import { useFiltersCountAppliedFromDropdown } from "~/hooks/filters/useFiltersCountAppliedFromDropdown";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const PublicMoreFiltersTrigger = /*#__PURE__*/ memo((param)=>{
    let { filters, customFields, availableTypes, otherFilters, disabledFilters, trackLocation } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const { filtersCount } = useFiltersCountAppliedFromDropdown({
        filtersToCount: filters,
        customFieldsToCount: customFields
    });
    const { clearSelectedFilters } = useFiltersDropdownController({
        availableFilters: filters,
        customFields,
        trackLocation
    });
    const renderFiltersDropdown = useCallback((param)=>{
        let { closePopover } = param;
        return /*#__PURE__*/ _jsx(PublicFiltersDropdown, {
            availableTypes: availableTypes,
            otherFilters: otherFilters,
            availableFilters: filters,
            customFields: customFields,
            title: "More filters",
            onApplyClick: closePopover,
            trackLocation: trackLocation,
            disabledFilters: disabledFilters
        });
    }, [
        availableTypes,
        customFields,
        disabledFilters,
        filters,
        otherFilters,
        trackLocation
    ]);
    const renderTrigger = useCallback((param)=>{
        let { isActive, onClick } = param;
        return /*#__PURE__*/ _jsxs("div", {
            className: "relative shrink-0",
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    appearance: isActive || filtersCount ? "outline" : searchImprovements ? "ghost" : "filled",
                    color: isActive || filtersCount ? "blue" : "grey",
                    className: filtersCount ? "pr-5" : "pr-2",
                    "data-testid": "MORE_FILTERS_TRIGGER",
                    onClick: onClick,
                    prefix: filtersCount ? /*#__PURE__*/ _jsx("span", {
                        className: "flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-24 bg-blue-11 px-1 text-center text-10 font-bold text-blue-1",
                        "data-testid": "MORE_FILTERS_TRIGGER_COUNT",
                        children: filtersCount
                    }) : /*#__PURE__*/ _jsx(Plus, {}),
                    size: "small",
                    suffix: !filtersCount && /*#__PURE__*/ _jsx(TriangleDown, {
                        className: "size-3"
                    }),
                    children: searchImprovements ? "More" : "More filters"
                }),
                !!filtersCount && /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    className: "absolute right-1 top-1/2 -translate-y-1/2",
                    color: isActive || filtersCount ? "blue" : "grey",
                    "data-testid": "MORE_FILTERS_TRIGGER_CLOSE",
                    icon: Close,
                    label: "Clear filters",
                    onClick: clearSelectedFilters,
                    size: "extra-small"
                })
            ]
        });
    }, [
        clearSelectedFilters,
        filtersCount,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(FiltersDropdownTrigger, {
        renderFiltersDropdown: renderFiltersDropdown,
        renderTrigger: renderTrigger
    });
});
PublicMoreFiltersTrigger.displayName = "PublicMoreFiltersTrigger";
